import tw from 'twin.macro'

export const Wrapper = tw.div`h-[223px]`
